// Mobile menu
// @ts-expect-error - window is not typed
window.toggleRibbonMenu = () => {
  const menu = document.getElementById("ribbon-mobile-menu");
  if (!menu) {
    return;
  }

  const isOpen = menu.classList.toggle("is-open");
  if (isOpen) {
    menu.classList.remove("opacity-0", "max-h-0", "pointer-events-none");
    menu.classList.add("opacity-100", "max-h-96", "pointer-events-auto");
  } else {
    menu.classList.add("opacity-0", "max-h-0", "pointer-events-none");
    menu.classList.remove("opacity-100", "max-h-96", "pointer-events-auto");
  }

  document.querySelectorAll(".ribbon-nav-icon-open").forEach((element) => {
    element.classList.toggle("hidden", isOpen);
  });
  document.querySelectorAll(".ribbon-nav-icon-close").forEach((element) => {
    element.classList.toggle("hidden", !isOpen);
  });
};

// @ts-expect-error - window is not typed
window.toggleRibbonSidebar = () => {
  const menu = document.getElementById("ribbon-sidebar-menu");
  if (!menu) {
    return;
  }

  const isOpen = !menu.classList.toggle("translate-x-full");
  document.documentElement.classList.toggle("overflow-hidden", isOpen);

  document.querySelectorAll(".ribbon-sidebar-icon-open").forEach((element) => {
    element.classList.toggle("hidden", isOpen);
  });
  document.querySelectorAll(".ribbon-sidebar-icon-close").forEach((element) => {
    element.classList.toggle("hidden", !isOpen);
  });
};
